import React from 'react';
import PropTypes from 'prop-types';
import FacilityListItem from './FacilityListItem';
import { Box } from '@mui/material';

const FacilityList = ({ facilities }) => {
  return (
    <Box display='flex' flexDirection='column' gap={1} my={2}>
      {facilities.map(item => {
        return <FacilityListItem key={item.documentId} facility={item} />;
      })}
    </Box>
  );
};

FacilityList.propTypes = {
  facilities: PropTypes.array.isRequired
};

export default FacilityList;
